import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import formMixin from '../../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import inputRules from '../../../../mixins/input-rules';
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import { get } from 'lodash';
export default {
  name: 'NiotaClassicDevicetypesPacketParserFunction',
  mixins: [formMixin, inputRules],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    switchParserMode: {
      type: Boolean,
      required: false,
      default: false
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    },
    callFromDeviceType: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      parserCodeExpansion: 1,
      parserConfigInternal: cloneDeep(this.parserConfig)
    };
  },
  computed: {
    modeClass: function modeClass() {
      return this.UiTheme ? 'dark' : 'light';
    },
    formElement: function formElement() {
      return this.$refs.form;
    },
    scriptEditorValue: function scriptEditorValue() {
      switch (this.parserConfigInternal.scriptType) {
        case 'javascript':
          return this.parserConfigInternal.custom_function_js;

        case 'elixir':
          return this.parserConfigInternal.custom_function_ex;

        case 'url':
          return this.parserConfigInternal.custom_function_url;

        default:
          return '';
      }
    }
  },
  watch: {
    UiTheme: function UiTheme() {
      this.cmOptions.theme = this.UiTheme ? 'base16-dark' : 'duotone-light';
    },
    parserConfig: {
      handler: function handler(newVal) {
        this.parserConfigInternal = cloneDeep(newVal);
      },
      deep: true
    }
  },
  created: function created() {
    if (this.parserConfigInternal.custom_function_ex) {
      this.parserConfigInternal.scriptType = 'elixir';
    } else if (this.parserConfigInternal.custom_function_url) {
      this.parserConfigInternal.scriptType = 'url';
    } else {
      this.parserConfigInternal.scriptType = 'javascript';
    }

    this.changedScriptType(this.parserConfigInternal.scriptType);
  },
  methods: {
    scriptParamsTransformer: function scriptParamsTransformer(payload, paramsFromForm) {
      var meta = {
        lora: {
          fport: parseInt(paramsFromForm.loraFramePort)
        },
        device_id: -1,
        device_type_id: -1
      };
      return [payload, meta];
    },
    changedScriptType: function changedScriptType(type) {
      this.parserConfigInternal.scriptType = type;

      if (this.parserConfigInternal.scriptType === 'elixir') {
        delete this.parserConfigInternal.custom_function_js;
        delete this.parserConfigInternal.custom_function_url;
        this.parserConfigInternal.custom_function_ex = this.parserConfigInternal.custom_function_ex || '';
      } else if (this.parserConfigInternal.scriptType === 'url') {
        delete this.parserConfigInternal.custom_function_js;
        delete this.parserConfigInternal.custom_function_ex;
        this.parserConfigInternal.custom_function_url = this.parserConfigInternal.custom_function_url || 'http://';
      } else {
        delete this.parserConfigInternal.custom_function_ex;
        delete this.parserConfigInternal.custom_function_url;
        this.parserConfigInternal.scriptType = 'javascript';
        this.parserConfigInternal.custom_function_js = this.parserConfigInternal.custom_function_js || '';
      }

      this.emitChanges();
    },
    emitChanges: function emitChanges() {
      var clonedParserConfig = cloneDeep(this.parserConfigInternal);
      this.$emit('config-updated', clonedParserConfig);
    },
    onCalculationChange: function onCalculationChange(newCalculateElements) {
      this.parserConfigInternal = _objectSpread(_objectSpread({}, this.parserConfigInternal), {}, {
        calculateElements: newCalculateElements
      });
      this.emitChanges();
    },
    onTypeDefinitionsUpdated: function onTypeDefinitionsUpdated(newVariables) {
      this.parserConfigInternal = _objectSpread(_objectSpread({}, this.parserConfigInternal), {}, {
        variables: newVariables
      });
      this.emitChanges();
    },
    onScriptChange: function onScriptChange(newScript) {
      if (this.parserConfigInternal.scriptType === 'elixir') {
        this.parserConfigInternal.custom_function_ex = newScript;
      } else if (this.parserConfigInternal.scriptType === 'url') {
        this.parserConfigInternal.custom_function_url = newScript;
      } else {
        this.parserConfigInternal.custom_function_js = newScript;
      }

      this.parserConfigInternal = cloneDeep(this.parserConfigInternal);
      this.emitChanges();
    },
    testParserFunction: function () {
      var _testParserFunction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, params) {
        var meta;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                meta = {
                  lora: {
                    fport: parseInt(params.loraFramePort)
                  },
                  device_id: -1
                };
                _context.prev = 1;

                if (!(typeof this.customTestFunction === 'function')) {
                  _context.next = 9;
                  break;
                }

                meta.device_driver_id = -1;
                _context.next = 6;
                return this.customTestFunction(payload, meta);

              case 6:
                return _context.abrupt("return", _context.sent);

              case 9:
                meta.device_type_id = -1;
                _context.next = 12;
                return this.testClassicDeviceTypeParser(payload, meta);

              case 12:
                return _context.abrupt("return", _context.sent);

              case 13:
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);
                return _context.abrupt("return", get(_context.t0, 'response.data.data', {
                  error: _context.t0.message
                }));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 15]]);
      }));

      function testParserFunction(_x, _x2) {
        return _testParserFunction.apply(this, arguments);
      }

      return testParserFunction;
    }(),
    testClassicDeviceTypeParser: function () {
      var _testClassicDeviceTypeParser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload, meta) {
        var accountData, apiKey;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return NiotaClassicApiService.accountsGet(this.accountId);

              case 3:
                accountData = _context2.sent;
                apiKey = get(accountData, 'data.account.data.realTimeApiKey');

                if (apiKey) {
                  _context2.next = 8;
                  break;
                }

                console.error('Account does not seem to have an API-key', this.accountId, accountData);
                return _context2.abrupt("return", {
                  error: 'Account does not seem to have an API-key'
                });

              case 8:
                _context2.next = 10;
                return NiotaClassicApiService.deviceTypesParsePayload({
                  parseConfig: {
                    parser: {
                      config: this.parserConfig,
                      type: this.parserType
                    },
                    payload: payload,
                    meta: meta
                  },
                  api_key: apiKey
                });

              case 10:
                return _context2.abrupt("return", _context2.sent);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                console.error('Test-payload parsing failed', get(_context2.t0, 'response.data.err', _context2.t0));
                return _context2.abrupt("return", {
                  error: _context2.t0
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function testClassicDeviceTypeParser(_x3, _x4) {
        return _testClassicDeviceTypeParser.apply(this, arguments);
      }

      return testClassicDeviceTypeParser;
    }()
  }
};